import {SliderMark} from "./SliderMark";

/**
 * ServicePropertySliderSettings содержит настройки поля фильтра типа слайдер.
 */
export class ServicePropertySliderSettings {
  /**
   * IsNeedShowCurrentValues позволяет включать/отключать отображение
   * текущих значений поля под слайдером.
   */
  public IsNeedShowCurrentValues: boolean = true

  /**
   * Префиксы и суффиксы для значений поля, выводимых под слайдером.
   * Префикс выводится перед значением, суффикс - после.
   */
  public FromValueMarkPrefix: string = ""
  public FromValueMarkSuffix: string = ""
  public ToValueMarkPrefix: string = ""
  public ToValueMarkSuffix: string = ""

  /**
   * ValueLabelDisplay позволяет задать отображение меток для слайдера.
   *  - off - выключено
   *  - on - всегда видны
   *  - auto - видны при наведении
   */
  public ValueLabelDisplay: 'on' | 'auto' | 'off' = "off"

  /**
   * Шаг изменения значения в слайдере. На эту величину будет меняться
   * общее значение при изменении положения селектора на 1 позицию.
   */
  public SliderStep: number = 1

  /**
   * Переключение слайдера только по заранее заданным точкам.
   * Нельзя будет выбрать промежуточные значения. Должен указываться
   * совместно со свойством ниже.
   */
  public IsByMarksOnly: boolean = false

  /**
   * Массив точек, выводимых на слайдере. Если включить флаг IsByMarksOnly,
   * то переключение будет возможно только по этим точкам.
   */
  public SliderPoints: SliderMark[] = []

  /**
   * IsLimitsFixed позволяет задать жесткие границы для слайдера.
   * Изначально границы считаются из действующих услуг.
   * При включенном флаге будут браться из настроек.
   */
  public IsLimitsFixed: boolean = false

  /**
   * Минимальное значение слайдера
   */
  public MinValue: number = 0

  /**
   * Максимальное значение слайдера
   */
  public MaxValue: number = 0

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServicePropertySliderSettings {
    let result = new ServicePropertySliderSettings();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServicePropertySliderSettings) => {
      // @ts-ignore
      result[key] = ServicePropertySliderSettings.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServicePropertySliderSettings>(
    field: T,
    data: any,
  ): any {
    let defaults = new ServicePropertySliderSettings()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "SliderStep":
      case "MinValue":
      case "MaxValue":
        return typeof data === "number" ? data : defaults[field]
      case "FromValueMarkPrefix":
      case "FromValueMarkSuffix":
      case "ToValueMarkPrefix":
      case "ToValueMarkSuffix":
        return typeof data === "string" ? data : defaults[field]
      case "ValueLabelDisplay":
        return typeof data === "string" && ['on', 'auto', 'off'].includes(data) ? data : defaults[field]
      case "IsNeedShowCurrentValues":
      case "IsByMarksOnly":
      case "IsLimitsFixed":
        return !!data
      case "SliderPoints":
        let valueData = data
        if (typeof data === "string") {
          valueData = JSON.parse(data)
        }

        let value = Array.isArray(valueData) ? valueData : []

        return value.map(v => SliderMark.RestoreSettings(v))
    }

    return defaults[field];
  }
}